/**
 * Product context utilities for extracting product ID from subdomain
 */

/**
 * Extract product ID from current hostname/subdomain
 * 
 * Examples:
 * - "gym.beahead.ai" -> "gym"
 * - "tasks.beahead.ai" -> "tasks"
 * - "localhost:3000" -> null (no subdomain)
 */
export function getProductIdFromSubdomain(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const hostname = window.location.hostname;
  
  // Remove port if present
  const host = hostname.split(':')[0];
  
  // Split by dots
  const parts = host.split('.');
  
  // Need at least 3 parts for subdomain (subdomain.domain.tld)
  if (parts.length < 3) {
    return null;
  }
  
  // First part is the subdomain
  const subdomain = parts[0];
  
  // Skip common non-subdomain prefixes
  if (subdomain in ['www', 'api', 'admin']) {
    return null;
  }
  
  // Map subdomain to product ID
  // This should match the backend configuration
  const subdomainToProduct: Record<string, string> = {
    'gym': 'gym',
    'tasks': 'tasks',
  };
  
  return subdomainToProduct[subdomain] || null;
}

/**
 * Get product ID from environment variable or subdomain
 */
export function getCurrentProductId(): string | null {
  // Check environment variable first
  const envProductId = import.meta.env.VITE_PRODUCT_ID;
  if (envProductId) {
    return envProductId;
  }
  
  // Fall back to subdomain extraction
  return getProductIdFromSubdomain();
}

